import { GetChannelApiKeys } from '@/connection/channel/api-keys';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const getApiKeysReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const apiKeys = await GetChannelApiKeys(channel);
        return apiKeys;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      pending: (state) => {
        state.loadingApiKeys = true;
      },
      fulfilled: (state, action) => {
        state.apiKeys = action.payload;
      },
      settled: (state) => {
        state.loadingApiKeys = false;
      },
    }
  );
};

export default getApiKeysReducer;
